module.exports = __webpack_public_path__ + "static/media/microsoft.ee5c8d9f.svg";